import { ChangeEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { EnterYourPassword, RememberPassword, SignIn, Unlock } from "../../../../constants";
import CommonLogo from "./common/CommonLogo";
import { routes } from "../../../../routers/routes";

const UnlockUser = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggle = () => setPasswordVisible(!isPasswordVisible);

  const { register, handleSubmit, setValue, watch, reset } = useForm({ defaultValues: { password: "", checkbox1: false } });
  const formData = watch();
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;
    setValue(id as keyof typeof formData, type === "checkbox" ? checked : value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit = handleSubmit(() => {
    reset({ password: "", checkbox1: false });
  });

  return (
    <div className="page-wrapper">
      <Container fluid className="p-0">
        <div className="authentication-main mt-0">
          <Row>
            <Col xs="12">
              <div className="login-card login-dark">
                <div>
                  <div>
                    <CommonLogo />
                  </div>
                  <div className="login-main">
                    <Form className="theme-form" onSubmit={onSubmit}>
                      <h4>{Unlock}</h4>
                      <FormGroup>
                        <Col>
                          <Label>{EnterYourPassword}</Label>
                        </Col>
                        <div className="form-input position-relative">
                          <Input {...register("password", { required: "Password is required" })} type={isPasswordVisible ? "text" : "password"} id="password" name="login[password]" required placeholder="*********" value={formData.password} onChange={handleInputChange} autoComplete="off" />
                          <div className="show-hide" onClick={toggle}>
                            <span className={!isPasswordVisible ? "show" : ""}></span>
                          </div>
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-0">
                        <div className="checkbox p-0">
                          <Input {...register("checkbox1")} type="checkbox" checked={formData.checkbox1} onChange={handleInputChange} />
                          <Label className="text-muted" htmlFor="checkbox1">
                            {RememberPassword}
                          </Label>
                        </div>
                        <Button color="primary" className="w-100" block>
                          {Unlock}
                        </Button>
                      </FormGroup>
                      <p className="mt-4 mb-0">
                        {"Already have an account?"}
                        <Link to={routes.Auth.Login.Simple} className="ms-2">
                          {SignIn}
                        </Link>
                      </p>
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
export default UnlockUser;
